import { Link } from 'react-router-dom';

const AssessmentCTA = () => {
  return (
    <section style={{
      padding: '5rem 5%',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Image */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1600&auto=format&fit=crop&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.08
      }} />

      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 20% 50%, rgba(37, 99, 235, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(13, 148, 136, 0.15) 0%, transparent 50%)',
        pointerEvents: 'none'
      }} />

      <div style={{
        maxWidth: '1000px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ textAlign: 'center' }}>
          {/* Badge */}
          <span
          className='stop-bleeding'
            style={{
              display: 'inline-block',
              padding: '0.5rem 1.25rem',
              background: 'rgba(239, 68, 68, 0.15)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '50px',
              color: '#f87171',
              fontWeight: '600',
              marginBottom: '1.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}
          >
            Stop the Silent Bleed
          </span>

          {/* Headline */}
          <h2
            style={{
              fontSize: 'clamp(2rem, 5vw, 3rem)',
              fontWeight: '700',
              color: 'white',
              marginBottom: '1rem',
              lineHeight: '1.2'
            }}
          >
            See How Much Inefficiency Is{' '}
            <span style={{
              background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Costing You
            </span>
          </h2>

          {/* Subtext */}
          <p
            style={{
              fontSize: '1.15rem',
              color: 'rgba(255, 255, 255, 0.7)',
              maxWidth: '650px',
              margin: '0 auto 2.5rem',
              lineHeight: '1.7'
            }}
          >
            Paper files, spreadsheets, and WhatsApp approvals are quietly draining your resources.
            Get a clear picture of where you're losing money—and how to fix it.
          </p>

          {/* Stats Row */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '3rem',
              marginBottom: '3rem',
              flexWrap: 'wrap'
            }}
          >
            {[
              { value: '30%', label: 'Avg. time lost to manual processes' },
              { value: '₦50M+', label: 'Annual cost of data errors' },
              { value: '2 weeks', label: 'Delayed month-end reporting' }
            ].map((stat, index) => (
              <div key={index} style={{ textAlign: 'center' }}>
                <div style={{
                  fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                  fontWeight: '700',
                  background: 'linear-gradient(135deg, #2563eb 0%, #0d9488 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  marginBottom: '0.25rem'
                }}>
                  {stat.value}
                </div>
                <div style={{
                  fontSize: '0.85rem',
                  color: 'rgba(255, 255, 255, 0.5)',
                  maxWidth: '150px'
                }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div >
            <Link
            className='contact-assess'
              to="/contact?service=transform"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
               
                background: 'linear-gradient(135deg, #2563eb 0%, #0d9488 100%)',
                borderRadius: '50px',
                color: 'white',
                
                textDecoration: 'none',
                transition: 'transform 0.3s ease, boxShadow 0.3s ease',
                boxShadow: '0 5px 20px rgba(37, 99, 235, 0.35)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 7px 25px rgba(37, 99, 235, 0.45)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 20px rgba(37, 99, 235, 0.35)';
              }}
            >
              <span>→</span>
              Book a 2-Hour Digital Operations Assessment
            </Link>
          </div>

          {/* Trust note */}
          <p
            style={{
              marginTop: '1.5rem',
              fontSize: '0.9rem',
              color: 'rgba(255, 255, 255, 0.4)'
            }}
          >
            No obligation. Get actionable insights you can implement immediately.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AssessmentCTA;
